export default "<div #content class=\"content {{ class }}\">\n    <ng-content></ng-content>\n</div>\n";